/**
 * Usonian CSS > Elements > Image
 */

import { css } from 'styled-components';

export default css`
  img {
    font-style: italic;
    max-width: 100%;
    vertical-align: middle;
  }

  svg {
    max-height: 100%;
  }
`;
